import { FrameComponent } from "../../common/FrameComponent";
import { APP_WHITEBOARD } from "../../services/api/constants";
import { useServiceUrl } from "../../common/hooks/use-service-url";

interface Props {
  className?: string;
}

export const Polls = ({ className }: Props) => {
  const src = useServiceUrl(APP_WHITEBOARD);

  return <FrameComponent src={src} />;
};
